import { ImageEditorComponent } from '@syncfusion/ej2-react-image-editor';
import React, { useRef, useState } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';
import { forceReloadContactDocuments } from '@hooks/API/Contact/UseContactMedia';

import { NwButton, NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .toolbar {
        margin: 2rem 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    /* A4 crop preset: label inside a paper-like bordered sheet. */
    .e-toolbar-item.custom-crop-a4 .e-tbar-btn {
        border: 1px solid #788087;
        border-radius: 1px;
        min-width: 0;
        height: 30px;
        padding: 0 1px;
        box-sizing: border-box;
        background: transparent;
        color: #788087;
    }

    .e-toolbar-item.custom-crop-a4 .e-tbar-btn:hover,
    .e-toolbar-item.custom-crop-a4 .e-tbar-btn:focus {
        background: transparent;
        color: #788087;
        border-color: #788087;
    }

    .e-toolbar-item.custom-crop-a4 .e-tbar-btn-text,
    .e-toolbar-item.custom-crop-a4 .e-tbar-btn:hover .e-tbar-btn-text,
    .e-toolbar-item.custom-crop-a4 .e-tbar-btn:focus .e-tbar-btn-text {
        color: #788087;
        font-size: 10px;
        line-height: 1;
        font-weight: 600;
        letter-spacing: 0.02em;
    }
`;

// Custom crop ratio added beside Syncfusion built-in presets (dropdown is not extensible via API).
const CUSTOM_CROP_RATIO = '70:99';
const CUSTOM_CROP_TOOLBAR_ID = 'custom-crop-a4';

const EditImageNew = ({ contactID, image, onImageCreated, onCancel }) => {
    let imgObj = useRef(null);
    const [uploading, setUploading] = useState(false);

    const toolbar = [
        'Crop',
        'Straightening',
        'Transform',
        'Finetune',
        'Filter',
        'Frame',
        'ZoomIn',
        'ZoomOut',
        'Reset',
        'Undo',
        'Redo',
        'Reset',
    ];
    const imageEditorCreated = () => {
        imgObj.current.open(image.Standard.Url);
    };

    const handleToolbarUpdating = (args) => {
        if (args.toolbarType !== 'crop-transform') {
            return;
        }

        const alreadyAdded = args.toolbarItems.some((item) => item.id === CUSTOM_CROP_TOOLBAR_ID);
        if (alreadyAdded) {
            return;
        }

        // Insert right after the built-in crop dropdown.
        args.toolbarItems.splice(1, 0, {
            id: CUSTOM_CROP_TOOLBAR_ID,
            text: 'A4',
            tooltipText: 'Crop A4 (70:99)',
            align: 'Center',
            cssClass: 'custom-crop-a4',
        });
    };

    const handleToolbarItemClicked = (args) => {
        const itemId = args?.item?.id;
        if (itemId !== CUSTOM_CROP_TOOLBAR_ID) {
            return;
        }
        imgObj.current.select(CUSTOM_CROP_RATIO);
    };

    const handleUpload = async () => {
        // const data = {
        //     base64Image: imageEditor.toDataURL().replace(/^data:image\/(png|jpg);base64,/, "")
        // };

        setUploading(true);
        let imageData = imgObj.current.getImageData();
        const canvas = document.createElement('canvas');
        canvas.width = imageData.width;
        canvas.height = imageData.height;
        const context = canvas.getContext('2d');
        context.putImageData(imageData, 0, 0);
        const data = {
            base64Image: canvas.toDataURL().replace(/^data:image\/(png|jpg);base64,/, ''),
        };
        Axios.post(`/documents/uploadBase64Picture/${contactID}`, data)
            .then((response) => {
                forceReloadContact(contactID);
                forceReloadContactDocuments(contactID);
                setUploading(false);
                onImageCreated(response);
            })
            .catch((error) => {
                console.error('upload image error => ', error);
                setUploading(false);
            });
    };

    return (
        <Wrapper>
            <div className="e-img-editor-sample">
                <ImageEditorComponent
                    id="image-editor"
                    ref={imgObj}
                    created={imageEditorCreated}
                    height="calc(100vh - 200px)"
                    toolbar={toolbar}
                    toolbarUpdating={handleToolbarUpdating}
                    toolbarItemClicked={handleToolbarItemClicked}
                />
            </div>
            <div className="toolbar">
                <NwCancelButton label="Cancel" icon={byPrefixAndName.fasl['times']} onClick={onCancel} />
                <NwSaveButton label="Save (as a new image)" onClick={handleUpload} loading={uploading} />
            </div>
        </Wrapper>
    );
};
export default EditImageNew;
